import React from 'react';
import { connect } from 'react-redux';
import {
	spotlightPeersSelector,
	videoBoxesSelector
} from '../../Selectors';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withRoomContext } from '../../../RoomContext';
import Peer from '../../Containers/Peer';
import Me from '../../Containers/Me';
import * as settingsActions from '../../../actions/settingsActions';
import * as roomActions from '../../../actions/roomActions';
import * as meActions from '../../../actions/meActions';
import Chat from '../../MeetingDrawer/Chat/Chat';
import { firestore } from '../../../lib/firebase';
import ScreenSharing from '../Common/ScreenSharing';

const PADDING_H = 50;

const styles = (theme) =>
	({
		root :
		{
			width          : '100%',
			height         : '100%',
			display        : 'flex',
			flexDirection  : 'row',
			flexWrap       : 'wrap',
			overflow       : 'hidden',
			justifyContent : 'space-around',
			alignItems     : 'center',
			alignContent   : 'center'
		},
		rootM :
		{
			width          : '100%',
			height         : '100%',
			display        : 'flex',
			flexDirection  : 'row',
			flexWrap       : 'wrap',
			overflow       : 'hidden',
			justifyContent : 'center',
			alignItems     : 'center',
			alignContent   : 'center'
		},
		rootML :
		{
			width          : '100%',
			height         : '100%',
			display        : 'flex',
			flexDirection  : 'row-reverse',
			flexWrap       : 'wrap',
			overflow       : 'hidden',
			justifyContent : 'space-between',
			alignItems     : 'center',
			alignContent   : 'center'
		},
		hiddenToolBar :
		{
			paddingTop : 0,
			transition : 'padding .5s'
		},
		showingToolBar :
		{
			transition : 'padding .5s'
		},
		buttonControlBar :
		{
			paddingLeft                    : PADDING_H,
			[theme.breakpoints.down('sm')] :
			{
				paddingLeft : 0
			}
		},
		leftArea :
		{
			width          : '25%',
			height         : '100%',
			padding        : '0.5%',
			display        : 'flex',
			justifyContent : 'center',
			flexDirection  : 'column',
			alignItems     : 'flex-start'
		},
		leftAreaTop :
		{
			display        : 'flex',
			flexDirection  : 'column',
			justifyContent : 'flex-end',
			height         : '70%',
			width          : '100%'
		},
		rightArea :
		{
			height         : '100%',
			width          : '71%',
			padding        : '1%',
			alignItems     : 'center',
			justifyContent : 'center',
			display        : 'flex'
		},
		topArea :
		{
			alignItems     : 'center',
			justifyContent : 'center',
			display        : 'flex',
			marginTop      : '2%'
		},
		bottomArea :
		{
			width          : '100%',
			maxWidth       : '90%',
			display        : 'flex',
			justifyContent : 'space-between',
			marginTop      : '4%',
			marginBottom   : '2%',
			padding        : '0 6% 0 0',
			alignItems     : 'flex-start',
			flexDirection  : 'row-reverse'
		},
		topAreaML :
		{
			height     : '100%',
			padding    : '4px',
			display    : 'flex',
			alignItems : 'flex-end'
		},
		bottomAreaML :
		{
			height         : '100%',
			display        : 'flex',
			justifyContent : 'flex-end',
			alignItems     : 'flex-end',
			padding        : '1%',
			flexDirection  : 'column'
		},
		control :
		{
			height         : '100%',
			display        : 'flex',
			justifyContent : 'flex-start',
			alignItems     : 'flex-start'
		},
		controlML :
		{
			height         : '100%',
			display        : 'flex',
			justifyContent : 'flex-start',
			alignItems     : 'flex-end',
			paddingBottom  : '5%'
		},
		controlBtn :
		{
			width           : '3rem',
			height          : '3rem',
			borderRadius    : '3rem',
			fontSize        : '0.6rem',
			backgroundColor : 'white',
			color           : '#adadac',
			boxShadow       : '2px 2px 4px #aaa',
			justifyContent  : 'center',
			alignItems      : 'center',
			display         : 'flex',
			lineHeight      : 1,
			whiteSpace      : 'nowrap',
			marginRight     : '3%',
			'&:hover'       :
				{
					opacity : 0.8
				}
		},
		controlBtnIcon :
		{
			width  : '64%',
			height : 'auto'
		}
	});

class GuestMeetingView extends React.PureComponent
{
	constructor(props)
	{
		super(props);

		this.state = {
			showChat      : true,
			swapVideo     : false,
			isChatFocused : false,
			initialSetup  : false
		};

		this.resizeTimeout = null;

		this.peersRightRef = React.createRef();
		this.peersRootRef = React.createRef();

		this.roomInfoListener = null;
	}

	updateDimensions = () =>
	{
		const {
			boxes,
			isMobile,
			orientation,
			guestHomeRef,
			setUseMobileView,
			setHideGuestButtomNavi
		} = this.props;

		// mobile keyboard shows up
		if (this.state.isChatFocused && isMobile)
		{

			setHideGuestButtomNavi(true);

			const currentRoot= this.peersRootRef.current;
			const rootWidth = currentRoot?.clientWidth || 0;
			const rootHeight = currentRoot?.clientHeight || 0;

			if (orientation === 'portrait')
			{
				this.setState({
					peerWidth  : rootWidth*0.8,
					peerHeight : rootHeight*0.8,
					meWidth    : 0,
					meHeight   : 0
				});
			}
			else
			{
				this.setState({
					peerWidth  : rootWidth*0.98,
					peerHeight : rootHeight*0.8,
					meWidth    : 0,
					meHeight   : 0
				});
			}
		}
		else
		{
			setHideGuestButtomNavi(false);
			// useMobileView state is not changed immediately
			let useMobileDesign = false;

			let orientationValue = '';

			let rate = 0.34;

			let paddingRate = 1;

			if (window.innerHeight < 480)
			{
				setUseMobileView({
					view        : true,
					orientation : 'landscape'
				});

				useMobileDesign = true;
				orientationValue = 'landscape';
				if (guestHomeRef.current)
				{
					guestHomeRef.current.style.height = '98%';
					guestHomeRef.current.style.minWidth = '100px';
					guestHomeRef.current.style.minHeight = '100px';
				}

			}
			else if (window.innerWidth < 750)
			{

				setUseMobileView({
					view        : true,
					orientation : 'portrait'
				});

				useMobileDesign = true;
				orientationValue = 'portrait';

				if
				(guestHomeRef.current)
				{
					guestHomeRef.current.style.height = '84%';
					guestHomeRef.current.style.minWidth = '100px';
					guestHomeRef.current.style.minHeight = '100px';
				}
			}
			else if (window.innerWidth < 830)
			{
				setUseMobileView({
					view        : false,
					orientation : ''
				});

				if
				(guestHomeRef.current)
				{
					guestHomeRef.current.style.height = '84%';
					guestHomeRef.current.style.minWidth = '100px';
					guestHomeRef.current.style.minHeight = '100px';
				}
			}
			else if (window.innerHeight > 750)
			{
				setUseMobileView({
					view        : false,
					orientation : ''
				});

				if
				(guestHomeRef.current)
				{
					guestHomeRef.current.style.height = '86%';
					guestHomeRef.current.style.minWidth = '750px';
					guestHomeRef.current.style.minHeight = '600px';
				}
			}
			else
			{
				setUseMobileView({
					view        : false,
					orientation : ''
				});

				if
				(guestHomeRef.current)
				{
					guestHomeRef.current.style.height = '82%';
					guestHomeRef.current.style.minWidth = '200px';
					guestHomeRef.current.style.minHeight = '100px';
				}
			}

			const currentRight = this.peersRightRef.current;

			const currentRoot= this.peersRootRef.current;

			if (!currentRight && !currentRoot)
				return;

			if (boxes === 0)
				return;

			const rightWidth = currentRight?.clientWidth || 0;
			const rightHeight = currentRight?.clientHeight || 0;
			const rootWidth = currentRoot?.clientWidth || 0;

			let rootHeight = currentRoot?.clientHeight || 0;

			if (isMobile || useMobileDesign)
			{
				rate = 0.48;

				if (orientation === 'portrait' || orientationValue === 'portrait')
				{
					paddingRate = 0.9;
				}
				else
				{
					// to avoid miscalculation after closing smartphone keyboard
					rootHeight = window.innerHeight;

					paddingRate = 0.975;
				}
			}

			let baseLength = 0;

			if (isMobile || useMobileDesign)
			{
				baseLength = (orientation === 'portrait' || orientationValue === 'portrait') ? rootWidth : rootHeight;
			}
			else
			{
				baseLength = rightWidth > rightHeight ? rightHeight : rightWidth;
			}

			let peerWidth = baseLength * paddingRate;

			let meWidth = baseLength * rate * paddingRate;

			if (isMobile || useMobileDesign)
			{
				if (orientation === 'portrait' || orientationValue === 'portrait')
				{
				// maxSize of peerWidth
					if (peerWidth > rootHeight * 0.63)
					{
						peerWidth = rootHeight * 0.63;
					}
					// height of 70% is peer in max case. max height of me is 0.63 * 0.45 = 0.2835
					meWidth = peerWidth * 0.45 * paddingRate;
				}
				else
				{
					// eslint-disable-next-line no-console
					console.log(`Sizing  peerWidth1 ${peerWidth} }`);

					// maxSize of peerWidth
					if (peerWidth > rootWidth * 0.575)
					{
						peerWidth = rootWidth * 0.575;
					}

					if (peerWidth > rootHeight *0.97 - 28)
					{
						peerWidth = rootHeight *0.97 - 28;
					}

					// eslint-disable-next-line no-console
					console.log(`Sizing  peerWidth2 ${peerWidth} }`);

					// width of 60% is peer in max case. max width of me is 0.575 * 0.5 = 0.2875
					meWidth = peerWidth*0.5*paddingRate;
				}
			}

			this.setState({
				meWidth      : Math.ceil(meWidth),
				meHeight     : Math.ceil(meWidth),
				peerWidth    : Math.ceil(peerWidth),
				peerHeight   : Math.ceil(peerWidth),
				initialSetup : true
			});
		}
	};

	setChatFocused = (value) =>
	{
		this.setState({
			isChatFocused : value
		});
	}

	changeCamera = () =>
	{
		const {
			me,
			settings,
			roomClient
		} = this.props;

		const cameras = me.webcamDevices;

		if (cameras.length <= 1)
		{
			return;
		}

		const _webCams = Object.keys(cameras).map((key) => cameras[key]);

		let i = 0;

		for (i = 0; i < _webCams.length; i++)
		{
			if (_webCams[i].deviceId === settings.selectedWebcam)
			{
				break;
			}
		}
		i++;
		if (i === _webCams.length)
		{
			i = 0;
		}

		roomClient.updateWebcam({
			restart     : true,
			newDeviceId : _webCams[i].deviceId
		});
	};

	fetchRoomInfo = () =>
	{
		const {
			roomName,
			roomState,
			setRoomInfo
		} = this.props;

		if (this.roomInfoListener)
		{
			this.roomInfoListener();
			this.roomInfoListener = null;
		}

		if (roomName && roomState === 'connected')
		{
			this.roomInfoListener = firestore.collection('rooms').doc(roomName)
				.onSnapshot((doc) =>
				{
					if (doc.exists)
					{
						setRoomInfo({
							id : doc.id,
							...doc.data()
						});
					}
				});
		}
	};

	componentDidMount()
	{
		// window.resize event listener
		window.addEventListener('resize', () =>
		{
			// eslint-disable-next-line no-console
			console.log('componentDidMount resize');

			// clear the timeout
			clearTimeout(this.resizeTimeout);

			// start timing for event "completion"
			this.resizeTimeout = setTimeout(() => this.updateDimensions(), 250);
		});

		this.updateDimensions();

		// set room info
		this.fetchRoomInfo();
	}

	componentWillUnmount()
	{
		window.removeEventListener('resize', this.updateDimensions);

		if (this.roomInfoListener)
		{
			this.roomInfoListener();
			this.roomInfoListener = null;
		}
	}

	componentDidUpdate(prevProps, prevState)
	{
		if (
			prevState.initialSetup !== this.state.initialSetup
			|| prevProps.isMobile !== this.props.isMobile
			|| prevProps.boxes !== this.props.boxes
			|| prevProps.orientation !== this.props.orientation
			// to detect change of orientation
			|| prevProps.roomOrientation !== this.props.roomOrientation
		)
		{
			setTimeout(() =>
			{
				this.updateDimensions();
			}, 80);
		}
		else if (
			prevProps.hideGuestBottomNavi !== this.props.hideGuestBottomNavi
			|| (prevState.isChatFocused !== this.state.isChatFocused
				&& this.state.isChatFocused === false)
		)
		{
			setTimeout(() =>
			{
				this.updateDimensions();
			}, 550);
		}

		const { settings } = prevProps;

		// facing mode changed
		if (settings.facingModeWebCam !== this.props.settings.facingModeWebCam)
		{
			if (this.props.settings.facingModeWebCam === 'environment')
			{
				// eslint-disable-next-line react/no-did-update-set-state
				this.setState({
					swapVideo : true
				});
			}
			else
			{
				// eslint-disable-next-line react/no-did-update-set-state
				this.setState({
					swapVideo : false
				});
			}
		}
	}

	render()
	{
		const {
			advancedMode,
			spotlightsPeers,
			toolbarsVisible,
			permanentTopBar,
			buttonControlBar,
			classes,
			isMobile,
			chatEnabled,
			orientation
		} = this.props;

		const isHost = false;

		const meStyle =
		{
			'width'  : this.state.meWidth,
			'height' : this.state.meWidth
		};

		const style =
		{
			'width'  : this.state.peerWidth,
			'height' : this.state.peerHeight
		};

		const chatStyle =
		{
			'width'  : isMobile ? this.state.peerWidth : this.state.meWidth,
			'height' : isMobile ? this.state.peerHeight : this.state.peerHeight - this.state.meHeight - 6
		};

		return (
			<div
				className={classnames(
					isMobile ?
						orientation === 'portrait' ? classes.rootM : classes.rootML
						:
						orientation === 'portrait' ? classes.root : classes.root,
					toolbarsVisible || permanentTopBar ?
						classes.showingToolBar : classes.hiddenToolBar,
					buttonControlBar ? classes.buttonControlBar : null
				)}
				ref={this.peersRootRef}
			>
				{ !isMobile ?
					<>
						<div className={classes.leftArea} >
							<div className={classes.leftAreaTop} style={chatStyle}>
								<Chat isHost={isHost} setChatFocused={this.setChatFocused}/>
							</div>
							{ !this.state.swapVideo ?
								<Me
									advancedMode={advancedMode}
									spacing={6}
									style={meStyle}
									width={this.state.meWidth}
									height={this.state.meHeight}
								/>
								:
								<>

									{ spotlightsPeers.map((peer) =>
									{
										return (
											<Peer
												key={peer}
												advancedMode={advancedMode}
												id={peer}
												spacing={6}
												style={meStyle}
												enableLayersSwitch
												width={this.state.meWidth}
												height={this.state.meHeight}
											/>
										);
									})}

								</>
							}
						</div>
						<div className={classes.rightArea} ref={this.peersRightRef}>
							{ !this.state.swapVideo ?
								<>
									{ spotlightsPeers.map((peer) =>
									{
										return (
											<Peer
												key={peer}
												advancedMode={advancedMode}
												id={peer}
												spacing={6}
												style={style}
												enableLayersSwitch
												width={this.state.peerWidth}
												height={this.state.peerHeight}
											/>
										);
									})}
								</>

								:
								<Me
									advancedMode={advancedMode}
									spacing={6}
									style={style}
									width={this.state.peerWidth}
									height={this.state.peerHeight}
								/>

							}
						</div>
					</>
					:
					<>
						{ !chatEnabled ?
							<div className={orientation === 'portrait' ? classes.topArea : classes.topAreaML}>
								{ !this.state.swapVideo ?

									<>
										{ spotlightsPeers.map((peer) =>
										{
											return (
												<Peer
													key={peer}
													advancedMode={advancedMode}
													id={peer}
													spacing={0}
													style={style}
													enableLayersSwitch
													width={this.state.peerWidth}
													height={this.state.peerHeight
													}
												/>
											);
										})}
									</>

									:
									<Me
										advancedMode={advancedMode}
										spacing={0}
										style={style}
										width={this.state.peerWidth}
										height={this.state.peerHeight}
									/>

								}
							</div>
							:
							<div className={orientation === 'portrait' ? classes.topArea : classes.topAreaML}>
								<div className={classes.fullscreen} style={
									!isMobile ? chatStyle : style}
								>
									<Chat isHost={isHost} setChatFocused={this.setChatFocused}/>
								</div>
							</div>
						}
						{ !this.props.hideGuestBottomNavi &&
						<div className={orientation === 'portrait'? classes.bottomArea : classes.bottomAreaML}>
							{ !this.state.swapVideo ?
								<>
									<Me
										advancedMode={advancedMode}
										spacing={0}
										style={meStyle}
										width={this.state.meWidth}
										height={this.state.meHeight}
									/>
									<div className={orientation === 'portrait' ? classes.control : classes.controlML}>
										<div
											className={classes.controlBtn}
											onClick={() => this.changeCamera()}
										>
											<img className={classes.controlBtnIcon} src='images/icon_guest_change_camera.svg' alt='camera' />
										</div>
									</div>
								</>
								:
								<>
									<>
										{ spotlightsPeers.map((peer) =>
										{
											return (
												<Peer
													key={peer}
													advancedMode={advancedMode}
													id={peer}
													spacing={6}
													style={meStyle}
													enableLayersSwitch
													width={this.state.meWidth}
													height={this.state.meHeight}
												/>
											);
										})}
									</>
									<div className={orientation === 'portrait' ? classes.control : classes.controlML}>
										<div
											className={classes.controlBtn}
											onClick={() => this.changeCamera()}
										>
											<img className={classes.controlBtnIcon} src='images/icon_guest_change_camera.svg' alt='camera' />
										</div>
									</div>
								</>
							}
						</div>
						}
					</>
				}
				<ScreenSharing advancedMode={advancedMode} />
			</div>
		);
	}
}

GuestMeetingView.propTypes =
{
	roomClient             : PropTypes.object.isRequired,
	advancedMode           : PropTypes.bool,
	boxes                  : PropTypes.number,
	spotlightsPeers        : PropTypes.array.isRequired,
	toolbarsVisible        : PropTypes.bool.isRequired,
	hideSelfView           : PropTypes.bool.isRequired,
	permanentTopBar        : PropTypes.bool.isRequired,
	buttonControlBar       : PropTypes.bool.isRequired,
	toolAreaOpen           : PropTypes.bool.isRequired,
	aspectRatio            : PropTypes.number.isRequired,
	classes                : PropTypes.object.isRequired,
	setAudioMuted          : PropTypes.func.isRequired,
	isMuted                : PropTypes.bool.isRequired,
	isMobile               : PropTypes.bool.isRequired,
	orientation            : PropTypes.string,
	roomOrientation        : PropTypes.string,
	chatEnabled            : PropTypes.bool.isRequired,
	settings               : PropTypes.object.isRequired,
	me                     : PropTypes.object.isRequired,
	roomName               : PropTypes.string.isRequired,
	roomState              : PropTypes.string.isRequired,
	setRoomInfo            : PropTypes.func.isRequired,
	setUseMobileView       : PropTypes.func.isRequired,
	hideGuestBottomNavi    : PropTypes.bool,
	setHideGuestButtomNavi : PropTypes.func.isRequired,
	guestHomeRef           : PropTypes.any
};

const mapStateToProps = (state) =>
{
	return {
		boxes            : videoBoxesSelector(state),
		spotlightsPeers  : spotlightPeersSelector(state),
		toolbarsVisible  : state.room.toolbarsVisible,
		hideSelfView     : state.room.hideSelfView,
		permanentTopBar  : state.settings.permanentTopBar,
		buttonControlBar : state.settings.buttonControlBar,
		toolAreaOpen     : state.toolarea.toolAreaOpen,
		aspectRatio      : state.settings.aspectRatio,
		isMuted          : state.settings.audioMuted,
		isMobile         : state.me.browser.platform === 'mobile' || state.me.useMobileView,
		roomOrientation  : state.room.orientation,
		orientation      : state.room.orientation ?
			state.room.orientation : state.me.useMobileOrientation,
		chatEnabled         : state.bottomNavigation.chatEnabled,
		settings            : state.settings,
		me                  : state.me,
		roomName            : state.room.name,
		roomState           : state.room.state,
		hideGuestBottomNavi : state.room.hideGuestBottomNavi,
		advancedMode        : state.settings.advancedMode
	};
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		setAudioMuted : (flag) =>
		{
			dispatch(settingsActions.setAudioMuted(flag));
		},
		setRoomInfo : (info) =>
		{
			dispatch(roomActions.setRoomInfo(info));
		},
		setUseMobileView : (useMobileView) =>
		{
			dispatch(meActions.setUseMobileView(useMobileView));
		},
		setHideGuestButtomNavi : (hideGuestBottomNavi) =>
		{
			dispatch(roomActions.setHideGuestButtomNavi(hideGuestBottomNavi));
		}
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room === next.room &&
				prev.peers === next.peers &&
				prev.producers === next.producers &&
				prev.consumers === next.consumers &&
				prev.room.spotlights === next.room.spotlights &&
				prev.room.toolbarsVisible === next.room.toolbarsVisible &&
				prev.room.hideSelfView === next.room.hideSelfView &&
				prev.room.orientation === next.room.orientation &&
				prev.room.name === next.room.name &&
				prev.room.state === next.room.state &&
				prev.settings.permanentTopBar === next.settings.permanentTopBar &&
				prev.settings.buttonControlBar === next.settings.buttonControlBar &&
				prev.settings.aspectRatio === next.settings.aspectRatio &&
				prev.settings.facingModeWebCam === next.settings.facingModeWebCam &&
				prev.settings === next.settings &&
				prev.me === next.me &&
				prev.toolarea.toolAreaOpen === next.toolarea.toolAreaOpen &&
				prev.bottomNavigation.chatEnabled === next.bottomNavigation.chatEnabled &&
				prev.me.useMobileView === next.me.useMobileView &&
				prev.me.useMobileOrientation === next.me.useMobileOrientation
			);
		}
	}
)(withStyles(styles, { withTheme: true })(GuestMeetingView)));